import React from 'react';
import styles from './styles.module.css';

import WarningIcon from '../../../../icons/Warning';

export default ({ title, message }) => (
  <div className={styles.container}>
    <WarningIcon color="#AD343E" size={null} />
    <div>
      {title && <h3>{title}</h3>}
      <p>{message}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/error-message/index.js